export const ValidacaoStatus = Object.freeze({
  AGUARDANDO_VALIDACAO: 'AGUARDANDO_VALIDACAO',
  APROVADA: 'APROVADA',
  REPROVADA: 'REPROVADA',
  BLOQUEAR: 'BLOQUEAR',
  COM_PENDENCIA: 'COM_PENDENCIA',
});
